import React from 'react';
import './HoroscopesIcon.scss';
import { HoroscopeIconCategory, HoroscopeIconType } from './HoroscopesIcon-Constants';

interface HoroscopesIconProps {
  type: HoroscopeIconType | HoroscopeIconCategory;
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
}

export const HoroscopesIcon: React.FC<HoroscopesIconProps> = ({
  type,
  width = 48,
  height = 48,
  className = '',
  onClick,
}) => {
  const getIconClass = () => {
    const baseClass = 'horoscopes-icon';
    const typeClass = `icon--${type}`;
    
    return [baseClass, typeClass, className].filter(Boolean).join(' ');
  };

  // const getIconName = (): string => {
  //   // For category icons, return the category type
  //   if (Object.values(HoroscopeIconCategory).includes(type as any)) {
  //     return type;
  //   }
    
  //   // For zodiac signs, return a generic icon name since we're using CSS background images
  //   return 'horoscope';
  // };

  return (
    <div
      className={getIconClass()}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
      data-testid="horoscopes-icon"
    />
  );
};
